import { CandidateSettingsConst, CountryCodesConst } from '@axiom/const';
import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';

const UkLawyerTypes = Object.keys(CandidateSettingsConst.UkLawyerType) as Array<
  keyof typeof CandidateSettingsConst.UkLawyerType
>;

const CountryCodes = Object.keys(
  CountryCodesConst.CountryCodesAbbreviations
) as Array<keyof typeof CountryCodesConst.CountryCodesAbbreviations>;

export const LawyerSpecificTypeSchema = z.object({
  countryCode: z.enum(ZodArrayToEnum(CountryCodes)),
  type: z.array(z.enum(ZodArrayToEnum(UkLawyerTypes))),
});

export const CandidateSettingsSchema = z.object({
  lawyerSpecificType: z.array(LawyerSpecificTypeSchema),
});

export type LawyerSpecificType = z.infer<typeof LawyerSpecificTypeSchema>;
export type CandidateSettings = z.infer<typeof CandidateSettingsSchema>;
